export interface EmptyStateProps {
  title: string;
  description?: string;
  /** 可选动作（如返回入口链接） */
  children?: React.ReactNode;
}

/** 空状态（资源加载失败/无内容时的静态降级容器） */
export function EmptyState({ title, description, children }: EmptyStateProps) {
  return (
    <div className='cs-empty'>
      <p className='cs-empty__title'>{title}</p>
      {description ? <p className='cs-empty__desc'>{description}</p> : null}
      {children}
    </div>
  );
}
